<template>
  <div class="tab-content-inner">
    <div class="info-alert">
      <CIcon name="cil-info" class="info-icon" />
      <div>
        <strong>Dicionário de Termos da IA:</strong> mapeia termos informais, abreviações e sinônimos para os nomes oficiais dos produtos, marcas e fornecedores do catálogo.
        Quando o cliente digita "coca", a IA entende que se trata de "Coca-Cola". Isso melhora a precisão das sugestões de pedido e buscas por voz/texto.
        <br />
        <strong>Tipos disponíveis:</strong>
        <em>Marca</em> (apelidos de marca),
        <em>Produto</em> (nomes populares de produto),
        <em>Fornecedor</em> (variações do nome do fornecedor),
        <em>Sinônimo</em> (termos genéricos) e
        <em>Dimensão</em> (embalagem, tamanho, etc).
      </div>
    </div>

    <div class="toolbar-actions">
      <CButton
        color="primary"
        size="sm"
        @click="showWizard = true"
      >
        <CIcon name="cil-lightbulb" class="mr-1" />
        Testar &amp; Treinar IA
      </CButton>
    </div>

    <TreinoChatIA
      :show.sync="showWizard"
      @trained="onTrained"
    />

    <PainelTermosNaoResolvidos
      ref="painelNaoResolvidos"
      @updated="onTrained"
    />

    <crud-base
      ref="crud"
      url="/admin/dicionario-ia"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :formInputs="formInputs"
      :enableSearch="true"
      primaryKey="id"
      :filters="filters"
      :useQueryString="false"
      :enableImport="true"
      importTitle="Importar Termos em Massa"
      :importTemplate="importTemplate"
    >
      <template v-slot:import-info>
        <div class="import-info-alert">
          <CIcon name="cil-info" class="import-info-icon" />
          <div>
            Envie um arquivo <strong>.csv</strong> seguindo o template.
            Colunas obrigatórias: <code>termo</code>, <code>termo_canonico</code>, <code>tipo</code>.
            <br />
            Tipos válidos: dimensao, marca, fornecedor, produto, sinonimo.
          </div>
        </div>
      </template>

      <template v-slot:filter-search>
        <select
          class="form-control form-control-sm filter-select"
          v-model="filters.tipo"
        >
          <option value="">Todos os tipos</option>
          <option
            v-for="t in tipos"
            :key="t.value"
            :value="t.value"
          >
            {{ t.label }}
          </option>
        </select>
      </template>

      <template v-slot:tipo="{model}">
        <span class="badge-tipo" :class="'tipo-' + model.tipo">
          {{ getLabelTipo(model.tipo) }}
        </span>
      </template>
    </crud-base>
  </div>
</template>

<script>
import CrudBase from "@/components/crud/CrudBase";
import TreinoChatIA from "./TreinoChatIA.vue";
import PainelTermosNaoResolvidos from "./PainelTermosNaoResolvidos.vue";

export default {
  name: "tab-dicionario",
  components: {
    CrudBase,
    TreinoChatIA,
    PainelTermosNaoResolvidos,
  },
  data() {
    return {
      showWizard: false,
      filters: {
        tipo: "",
      },
      tipos: [
        { value: "dimensao", label: "Dimensão" },
        { value: "marca", label: "Marca" },
        { value: "fornecedor", label: "Fornecedor" },
        { value: "produto", label: "Produto" },
        { value: "sinonimo", label: "Sinônimo" },
      ],
      columns: [
        { label: "Termo", field: "termo", sortable: false },
        { label: "Termo Canônico", field: "termo_canonico", sortable: false },
        { label: "Tipo", field: "tipo", sortable: false, useSlot: true },
        { label: "Cadastrado por", field: "autor_nome", sortable: false },
      ],
      importTemplate: {
        header: "termo;termo_canonico;tipo;dimensao_tipo;dimensao_id",
        rows: [
          "coca;Coca-Cola;marca;;",
          "pepsi;Pepsi-Cola;marca;;",
          "latao;Lata 473ml;dimensao;embalagem;1",
          "refri;Refrigerante;sinonimo;;",
          "ambev;Ambev S/A;fornecedor;;",
          "guarana antartica;Guaraná Antarctica Lata 350ml;produto;;",
        ],
        filename: "template_dicionario_ia.csv",
      },
    };
  },
  computed: {
    formInputs() {
      return {
        termo: {
          type: "string",
          ui: {
            label: "Termo",
            columns: 12,
            placeholder: "Ex: coca, pepsi, skol...",
          },
          rules: {
            required: { value: true, errMsg: "Campo obrigatório" },
          },
        },
        termo_canonico: {
          type: "string",
          ui: {
            label: "Termo Canônico",
            columns: 12,
            placeholder: "Ex: Coca-Cola, Pepsi-Cola, Skol...",
          },
          rules: {
            required: { value: true, errMsg: "Campo obrigatório" },
          },
        },
        tipo: {
          type: "string",
          default: "",
          ui: {
            widget: "select",
            label: "Tipo",
            columns: 12,
            widgetConfig: {
              enumSource: [
                { label: "Selecione...", value: "" },
                ...this.tipos.map((t) => ({
                  label: t.label,
                  value: t.value,
                })),
              ],
            },
          },
        },
        dimensao_tipo: {
          type: "string",
          ui: {
            label: "Dimensão Tipo",
            columns: 6,
            placeholder: "Ex: embalagem, tamanho...",
            hidden: "dx: {{$root.tipo}} !== 'dimensao'",
          },
        },
        dimensao_id: {
          type: "number",
          ui: {
            label: "Dimensão ID",
            columns: 6,
            placeholder: "ID da dimensão",
            hidden: "dx: {{$root.tipo}} !== 'dimensao'",
          },
        },
      };
    },
  },
  methods: {
    getLabelTipo(tipo) {
      const found = this.tipos.find((t) => t.value === tipo);
      return found ? found.label : tipo;
    },
    onTrained() {
      // Recarregar lista do CRUD após treino
      if (this.$refs.crud) {
        this.$refs.crud.loadData();
      }
    },
  },
};
</script>

<style scoped>
.tab-content-inner {
  padding: 20px;
}

.info-alert {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  background: #edf8f9;
  border: 1px solid #c5e6e9;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #344054;
  line-height: 1.5;
}

.info-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #2298a3;
}

.toolbar-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.filter-select {
  width: auto;
  min-width: 180px;
}

.badge-tipo {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.tipo-dimensao {
  background: #edf8f9;
  color: #2298a3;
}

.tipo-marca {
  background: #f2f2f8;
  color: #3a3e81;
}

.tipo-fornecedor {
  background: #fff3e0;
  color: #e65100;
}

.tipo-produto {
  background: #e8f5e9;
  color: #2e7d32;
}

.tipo-sinonimo {
  background: #fce4ec;
  color: #c62828;
}

.import-info-alert {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  background: #edf8f9;
  border: 1px solid #c5e6e9;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #344054;
  line-height: 1.5;
}

.import-info-alert code {
  background: #fff;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 12px;
}

.import-info-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #2298a3;
}
</style>
